import { createFileRoute } from "@tanstack/react-router"

import { InvitePage } from "@/pages/invite/invite-page"

// Public route (outside `_authenticated`): the page itself handles signed-out vs signed-in.
export const Route = createFileRoute("/invite/$token")({
	component: InvitePage,
})
